import { AppealDataService } from '@omni/data-services/appeal/appeal.data.service';
import { AddressDataService } from './../address/address.data.service';
import { FieldMaterialManagementService } from "@omni/services/field-materials/field-material-management.service";
import { ProcedureTrackerActivityDataService } from './../procedure-tracker-activity/procedure-tracker-activity.data.service';
import { EntitySyncInfo } from '@omni/data-services/delta/delta.service';
import { LocalizationService } from './../../services/localization/localization.service';
import { Injectable, inject } from '@angular/core';
import { NextCallObjectiveDataService } from '../../data-services/next-call-objective/next.call.objective.data.service';
import { AllocationShipmentDataService } from '../../data-services/sample/allocation-shipment.data.service';
import { SchedulerDataService } from '../../data-services/scheduler/scheduler.data.service';
import { AccountOfflineService } from '../../services/account/account.offline.service';
import { ActivityService } from '../../services/activity/activity.service';
import { SettingsService } from '../../services/app-settings/settings.service';
import { AuthenticationService } from '../../services/authentication.service';
import { BrandOfflineService } from '../../services/brand/brand.service';
import { CallPlanOfflineService } from '../../services/call-plan/call-plan.offline.service';
import { CaseManagementService } from '../../services/case-management/case-management.service';
import { CoachingReportService } from '../../services/coaching/coaching.report.service';
import { ConsentService } from '../../services/consent/consent.service';
import { ContentMatchingService } from '../../services/content-matching/content-matching.service';
import { CustomerEventsService } from '../../services/customer-event/customer-events.service';
import { DeviceService } from '../../services/device/device.service';
import { DynamicFormsService } from '../../services/dynamic-forms/dynamic-forms-service';
import { EmailService } from '../../services/email-templates/email.service';
import { GlobalUtilityService } from '../../services/global-utility.service';
import { MarketScanService } from '../../services/market-scan/market-scan.service';
import { PollService } from '../../services/poll/poll.service';
import { PresentationService } from '../../services/presentation/presentation.service';
import { SampleService } from '../../services/sample/sample.service';
import { SchedulerService } from '../../services/scheduler/scheduler.service';
import { TimeOffService } from '../../services/time-off/time-off.service';
import { XperiencesService } from '../../services/xperiences/xperiences.service';
import { AccountManagementDataService } from '../account-management/account-management.data.service';
import { AccountDataService } from '../accounts/account.data.service';
import { ActivityDataService } from '../activity/activity.service';
import { BrandDataService } from '../brand/brand.data.service';
import { CallPlanDataService } from '../call-plan/call-plan.data.service';
import { CaseManagementDataService } from '../case-management/case-management.data.service';
import { ContactDataService } from '../contact/contact.data.service';
import { EventsToolDataService } from '../event/events-tool.data.service';
import { FollowUpActivityDataService } from '../follow-up-activity/follow-up-activity.data.service';
import { LocationService } from '../location/location.data.service';
import { PresentationDataService } from '../presentation/presentation.data.service';
import { ReportDataService } from '../report/report.data.service';
import { ResourceDataService } from '../resource/resource.data.service';
import { AllocationTransferDataService } from '../sample/allocation-transfer.data.service';
import { SampleDataService } from '../sample/sample.data.service';
import { ScientificActivityDataService } from '../scientific-activity/scientific-activity.data.service';
import { TherapeuticAreaDataService } from '../therapeutic-area/therapeutic-area.data.service';
import { TimeOffDataService } from '../time-off/time-off.data.service';
import { WebsocketDataService } from '../websocket/websocket.data.service';
import { AuthenticationDataService } from './../authentication/authentication.service';
import { OpportunityManagementDataService } from './../opportunity-management/opportunity-management.data.service';
import { OrderActivityDataService } from './../order-activity/order-activity.data.service';
import { SearchConfigDataService } from './../search-config/search-config-data-service';
import { SharedDataService } from './../shared-data/shared.data.service';
import { SecInfoConfigDataService } from '../sec-info-config/sec-info-config-data-service';
import { MdmService } from "@omni/services/mdm/mdm.service";
import { ActivityType } from '@omni/classes/activity/activity.class';
import { DeltaService } from '../delta/delta.service';
import { ServerOrdersService } from '@omni/services/order-capture/server-orders.service';
import { SurgeryOrderActivityDataService } from '../surgery-order-activity/surgery-order-activity.data.service';
import { ExternallinksDataService } from '../externallink/externallinks.data.service';
import { AllocationAdjustmentDataService } from '../sample/allocation-adjust.data.service';
import { AllocationFeatureService } from './../../services/sample/allocation.feature.service';
import { SurveyService } from '@omni/services/survey/survey.service';
import { MyAssistantService } from "@omni/services/my-assistant/my-assistant.service";

import { VeevaWidgetService } from "@omni/services/veeva-widget/veeva-widget.service";
import { CustomerAssessService } from '@omni/services/customer-assess/customer-assess.service';
import { AddressService } from '@omni/services/address/address.service';
import { MeetingDataService } from '@omni/data-services/meeting/meeting.data.service';
import { MarketingPlanManagementDataService } from "../marketing-plan/marketing-plan-management.data.service";
import { AllocationInventoryDataService } from "../sample/allocation-inventory.data.service";
import { QuoteToolDataService } from "../quote-tool/quote-tool-data.service";
import { PharmacovigilanceDataService } from '../pharmacovigilance-reporting/pharmacovigilance.data.service';
import { KOLStatusService } from '@omni/services/kol-status/kol-status-service';
import { TerritoryManagementDataService } from '../territory-management/territory-management.data.service';
import { MedicalInsightService } from '@omni/services/medical-insight/medical-insight-service';
import { StoreCheckService } from '@omni/services/store-check/store-check.service';
import { ProcedureContractService } from '../procedure-contract/procedure-contract.service';
import { SetBookingDataService } from '../set-booking/set-booking.data.service';
import { UIService } from '../../services/ui/ui.service';
import { EventsService } from '@omni/services/events/events.service';
import { RxSalesDataService } from '@omni/services/contact-spotlight/rxsalesdata.service';
import { AdoptionLadderJourneyService } from '@omni/services/adoption-ladder-journey/adoption-ladder-journey.service';
import { BricksService } from '@omni/services/bricks/bricks.service';
import { BrickPositionService } from '@omni/services/bricks/brick-position.service';
import { AgentConfigService } from '@omni/ai/services/agent-config.service';
import { AssistantChatFeature } from '@omni/ai/features/assistant-chat.feature';
import { SampleReconciliationService } from '@omni/services/sample/sample-reconciliation.service';
import { SampleDeliveryRequestService } from '@omni/services/sample/sample-delivery-request.service';
import { MedicalInquiryDataService } from '../medical-inquiry/medical-inquiry.data.service';
import { RxTrendsDataService } from '../rx-trends/rx-trends.data.service';
import { SampleDeliveryRequestDataService } from '../sample/sample-delivery-request.data.service';
import { SyncProfilerService } from '../../services/logging/sync-profiler.service';
import { VoiceNoteService } from '@omni/services/voice-note/voice-note.service';
import { MeetingExpenseService } from '@omni/services/meeting-expense/meeting-expense.service';
import { MeetingExpenseSyncService } from '@omni/services/meeting-expense/meeting-expense-sync.service';
import { AppUiRecordDataService } from '@omni/data-services/app-ui/app-ui-record.data.service';
import { promisePool } from '../../utility/promise-pool';

/** Lets the sync pool's first wave claim its HTTP semaphore slots first. */
const RX_TRENDS_SYNC_START_DELAY_MS = 5000;

@Injectable({
  providedIn: 'root'
})
export class MasterDataService {
  readonly #assistantChatFeature = inject(AssistantChatFeature);

  constructor(
    private readonly accountService: AccountDataService,
    private readonly accountOfflineService: AccountOfflineService,
    private readonly activityService: ActivityDataService,
    private readonly activityOfflineService: ActivityService,
    private readonly brandService: BrandDataService,
    private readonly brandOfflineService: BrandOfflineService,
    private readonly contactService: ContactDataService,
    private readonly sampleDeliveryRequestService: SampleDeliveryRequestService,
    private readonly presentationService: PresentationDataService,
    private readonly resourceService: ResourceDataService,
    private readonly callPlanService: CallPlanDataService,
    private readonly device: DeviceService,
    private readonly locationService: LocationService,
    private readonly callPlanOfflineService: CallPlanOfflineService,
    private readonly presentationOfflineService: PresentationService,
    private readonly websocketService: WebsocketDataService,
    private readonly timeOffDataService: TimeOffDataService,
    private readonly timeOffService: TimeOffService,
    private readonly schedulerDataService: SchedulerDataService,
    private readonly schedulerService: SchedulerService,
    private readonly sampleDataService: SampleDataService,
    private readonly sampleService: SampleService,
    private readonly allocationShipmentDataService: AllocationShipmentDataService,
    private readonly allocFeatureService: AllocationFeatureService,
    private readonly allocationAdjustmentDataService: AllocationAdjustmentDataService,
    private readonly coachingReportService: CoachingReportService,
    private readonly consentService: ConsentService,
    private readonly utilityService: GlobalUtilityService,
    private readonly emailService: EmailService,
    private readonly contentMatchingService: ContentMatchingService,
    private readonly authenticationService: AuthenticationService,
    private readonly pollService: PollService,
    private readonly accountManagementDataService: AccountManagementDataService,
    private readonly followUpActivityDataService: FollowUpActivityDataService,
    private readonly caseManagementDataService: CaseManagementDataService,
    private readonly therapeuticAreaDataService: TherapeuticAreaDataService,
    private readonly orderActivityDataService: OrderActivityDataService,
    public readonly sharedDataService: SharedDataService,
    private readonly xperiencesService: XperiencesService,
    private readonly caseManagementService: CaseManagementService,
    private readonly customerEventsService: CustomerEventsService,
    private readonly allocTransferDataService: AllocationTransferDataService,
    public readonly authDataService: AuthenticationDataService,
    private readonly sapDataService: ScientificActivityDataService,
    public readonly opportunityService: OpportunityManagementDataService,
    public readonly settingsService: SettingsService,
    public readonly searchConfigDataService: SearchConfigDataService,
    private readonly dynamicsFormService: DynamicFormsService,
    private readonly reportsDataService: ReportDataService,
    private readonly nextCallObjectiveDataService: NextCallObjectiveDataService,
    private readonly marketScanService: MarketScanService,
    private readonly eventsToolDataService: EventsToolDataService,
    private readonly secInfoDataService: SecInfoConfigDataService,
    private readonly mdmService: MdmService,
    private readonly deltaService: DeltaService,
    private readonly surgeryOrderDataService: SurgeryOrderActivityDataService,
    private readonly procedureTrackerActivityDataService: ProcedureTrackerActivityDataService,
    private readonly externallinksDataService: ExternallinksDataService,
    private readonly localizationService: LocalizationService,
    private readonly surveyService: SurveyService,
    private readonly myAssistantService: MyAssistantService,

    private readonly veevaService: VeevaWidgetService,
    private readonly customerAssessService: CustomerAssessService,
    private readonly addressService: AddressService,
    private readonly fieldMaterialManagementService: FieldMaterialManagementService,
    private readonly meetingDataService: MeetingDataService,
    private readonly marketingPlanManagementDataService: MarketingPlanManagementDataService,
    private readonly allocationInventoryDataService: AllocationInventoryDataService,
    private readonly quoteService: QuoteToolDataService,
    private readonly addressDataService: AddressDataService,
    private readonly salesOrderDataService: OrderActivityDataService,
    private readonly pharmacovigilanceDataService: PharmacovigilanceDataService,
    private readonly kolStatusService: KOLStatusService,
    private readonly territoryDataService: TerritoryManagementDataService,
    private readonly medicalInsightService: MedicalInsightService,
    private readonly storeCheckService: StoreCheckService,
    private readonly appealDataService: AppealDataService,
    private readonly procedureContractService: ProcedureContractService,
    private readonly setBookingDataService: SetBookingDataService,
    private readonly uiService: UIService,
    private readonly events: EventsService,
    private readonly rxSalesDataService: RxSalesDataService,
    private readonly adoptionLadderJourneyService: AdoptionLadderJourneyService,
    private readonly bricksService: BricksService,
    private readonly brickPositionService: BrickPositionService,
    private readonly agentConfigService: AgentConfigService,
    private readonly sampleReconciliationService : SampleReconciliationService,
    private readonly medicalInquiryDataService: MedicalInquiryDataService,
    private readonly rxTrendsDataService: RxTrendsDataService,
    private readonly sampleDeliveryRequestDataService: SampleDeliveryRequestDataService,
    private readonly syncProfilerService: SyncProfilerService,
    private readonly voiceNoteService: VoiceNoteService,
    private readonly meetingExpenseService: MeetingExpenseService,
    private readonly meetingExpenseSyncService: MeetingExpenseSyncService,
    private readonly appUiRecordDataService: AppUiRecordDataService,
    private readonly serverOrdersService: ServerOrdersService
  ) {
  }

  async uploadOfflineData(syncDebugSyncInfo: EntitySyncInfo, isPartialUpload = false) {
    // Default partial upload data count per entity
    const maxRecordCountForPartialUpload = 10;
    /*
        Added payload for offline medical inquiries
        TC-1063
    */
    this.clearFilter();
    try {
      return await Promise.allSettled([
        /**
         *  PLEASE READ this before adding another offline upload function here.
         *
         *  When a new offline feature gets added, please keep in mind that
         *  offline data count should be tracked during local CRUD process.
         *  There is offline data check that happens before triggering a sync.
         *  However, due to bad pouchDB performance, checking all offline entities
         *  from pouchDB takes almost 10 seconds with Samsung A6. (our target device)
         *  Hence, as a work around, we've changed to track offline data count on the fly
         *  at the time of each entity's CRUD operation.
         *
         *  Tracking can be done anyway you want but it has to be efficient.
         *  Please update "OFFLINE_DATA_COUNT_ENTITY_NAME" and
         *  "isThereOfflineDataToBeUploaded" function in DiskService.
         *  Your new offline feature should use "getOfflineDataCount" & "setOfflineDataCount" to track the count.
         *
         *  Also, "isPartialUpload" flag is needed for small data upload in a certain scenario.
         *  All of the offline upload function should implement the functionality.
         *  Please refer existing offline upload functions for better understanding.
         */
        await this.opportunityService.uploadOfflineOpportunities(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineData: 1: ', e)),
        // MI offline-upload is chained after meeting upload so MIs created from an offline meeting
        // can be linked to the now-synced appointment via its real Dynamics GUID (Scenario B in
        // medical-inquiry.data.service.resolveAppointmentRef). MIs whose meeting hasn't synced
        // this cycle are deferred by uploadPendingMedicalInquiries and retried on the next sync.
        // Voice notes ride the same chain for the same reason: a note filed against a meeting the
        // rep created offline carries that meeting's offline id until the upload above swaps in
        // the real one, and VoiceNoteService defers any note it still cannot resolve.
        this.activityService.uploadOfflineMeetingsTimeOffsAllocationsEmailsFollowupsConsents(syncDebugSyncInfo, isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineData: 3: ', e))
          .then(() => this.meetingDataService.uploadMeetingNotesOnline().catch(e => console.error('uploadOfflineData: 15: ', e)))
          .then(() => this.medicalInquiryDataService.uploadPendingMedicalInquiries().catch(e => console.error('uploadOfflineData: 25: ', e)))
          // SDR offline-upload is chained after meeting upload for the same reason as MI:
          // an SDR raised from an offline meeting links to the now-synced appointment.
          // SDRs whose meeting hasn't synced this cycle are deferred by
          // uploadPendingSdrs (offline temp-id guard) and retried next sync (OMNI-61002).
          .then(() => this.sampleDeliveryRequestDataService.uploadPendingSdrs().catch(e => console.error('uploadOfflineData: 26: ', e)))
          .then(() => this.sampleDeliveryRequestDataService.uploadPendingSdrScraps().catch(e => console.error('uploadOfflineData: 27: ', e)))
          // A note converted into a meeting binds that meeting's id, so the push runs
          // after the meeting upload; a note whose meeting has not synced yet defers
          // itself and is retried next cycle.
          .then(() => this.voiceNoteService.pushOfflineData().catch(e => console.error('uploadOfflineData: 28: ', e)))
          // Expenses bind their meeting by id, so they too wait for the meeting upload above.
          .then(() => this.meetingExpenseService.uploadPending().catch(e => console.error('uploadOfflineData: 29: ', e)))
          .then(() => this.appUiRecordDataService.pushOfflineData().catch(e => console.error('uploadOfflineData: 30: ', e))),
        this.activityService.uploadOfflineDataForOrders(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineData: 3: ', e)),
        this.presentationService.syncOfflineFavourites().catch(e => console.error('uploadOfflineData: 4: ', e)),
        this.coachingReportService.uploadOfflineCoachingReports(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineData: 6: ', e)),
        this.coachingReportService.loadCoachingNoteFromDB().catch(e => console.error('uploadOfflineData: 6: ', e)),
        this.searchConfigDataService.uploadOfflineSavedSearchData().catch(e => console.error('uploadOfflineData: 7: ', e)),
        this.contactService.uploadCustomerNotesOnline().catch(e => console.error('uploadOfflineData: 8: ', e)),
        this.nextCallObjectiveDataService.uploadOfflineNextCallObjectives().catch(e => console.error('uploadOfflineData: 9: ', e)),
        this.marketScanService.uploadOfflineMarketScans(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineMarketScan: 10', e)),
        this.eventsToolDataService.uploadOfflineEventsToolData(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineEventsToolData: 11', e))
          .then(() => this.customerEventsService.uploadOfflineEventRegistrationResponse(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineData: 5: ', e))),
        this.accountService.uploadAccountNotesOnline().catch(e => console.error('uploadOfflineData: 12: ', e)),
        this.contactService.uploadOfflineContactTag().catch(e => console.error('uploadOfflineData: 13: ', e)),
        this.addressService.uploadPreferredAddressOnline().catch(e => console.error('uploadOfflineData: 14: ', e)),
        this.contactService.uploadOfflineContacts(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineData: 16: ', e)),
        this.contactService.uploadOfflineLinkedEntities(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineData: 17: ', e)),
        this.customerAssessService.uploadOfflineContactAssessments(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineData: 18: ', e)),
        this.contactService.uploadOfflineBusinessCRs(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineData: 19: ', e)),
        this.contactService.uploadOfflineOneKeyCRs(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineData: 20: ', e)),
        this.accountService.uploadOfflineAccountTag().catch(e => console.error('uploadOfflineData: 21: ', e)),
        this.customerAssessService.uploadOfflineContactSurveys(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineData: 22: ', e)),
        this.customerAssessService.uploadOfflineAccountSurveys(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineData: 23: ', e)),
        this.procedureContractService.UploadOfflineProcedureContracts().catch(e => console.error('uploadOfflineData: 24: ', e)),
        // medicalInquiryDataService.uploadPendingMedicalInquiries() is chained onto the meeting
        // upload above so it runs AFTER meeting upload + meeting notes; see comment there.
        // this.customerAssessService.uploadOfflineAccountAssessments(isPartialUpload, maxRecordCountForPartialUpload).catch(e => console.error('uploadOfflineData: 19: ', e)),
        /**
         *  PLEASE READ ABOVE!!
         */
      ]).then(() => true).catch((e) => { console.error('uploadOfflineData: ', e); return false; });
    } finally {
      this.events.publish('refreshAgenda');
      this.uiService.toolsActivityActive = false;
    }
  }

  async purgeData(maxEndDateUnixTimestamp: number): Promise<any> {
    return Promise.allSettled([
      this.activityOfflineService.purgeData(maxEndDateUnixTimestamp),
      this.timeOffService.purgeData(maxEndDateUnixTimestamp),
      this.sampleService.purgeData(),
      this.allocFeatureService.purgeData(maxEndDateUnixTimestamp),
      this.callPlanOfflineService.purgeData(maxEndDateUnixTimestamp),
      this.schedulerService.purgeData(maxEndDateUnixTimestamp),
      this.caseManagementService.purgeData(maxEndDateUnixTimestamp),
      this.customerEventsService.purgeData(maxEndDateUnixTimestamp),
      this.accountManagementDataService.purgeData(maxEndDateUnixTimestamp),
      this.sapDataService.purgeData(maxEndDateUnixTimestamp),
      this.marketScanService.purgeData(maxEndDateUnixTimestamp),
      this.eventsToolDataService.purgeData(maxEndDateUnixTimestamp),
      this.reportsDataService.purgeData(maxEndDateUnixTimestamp),
      this.surgeryOrderDataService.purgeData(maxEndDateUnixTimestamp),
      this.procedureTrackerActivityDataService.purgeData(maxEndDateUnixTimestamp)
    ]);
  }

  async checkUserDataChangeAndCleanDbIfFullSyncRequired(didOfflineDataUploadFail: boolean): Promise<boolean> {
    await this.activityService.getUserData(didOfflineDataUploadFail);
    return this.authenticationService.shouldFullSync;
  }

  /**
   * Pulls data without blocking UI
   */
  async nonBlockingSyncData(forceFullSync = false): Promise<any> {
    return Promise.allSettled([
      this.xperiencesService.fetchXperiencesData(),
    ]);
  }

  async onlyContactSync(forceFullSync = false, loadFromDBOnly = false): Promise<any> {
    return Promise.allSettled([this.contactService.syncContacts(forceFullSync, loadFromDBOnly)]);
  }

  async remapTimeOffFromDisk(): Promise<void> {
    await this.timeOffDataService.remapFromDisk();
  }

  private _syncData$ = Promise.resolve();

  async syncData(forceFullSync = false, loadFromDBOnly = false, forceNetwork?: boolean, isLoginSync = false) {
    await this._syncData$;
    const syncData$ = this._syncDataInternal(forceFullSync, loadFromDBOnly, forceNetwork, isLoginSync);
    this._syncData$ = syncData$;
    return syncData$;

  }

  /**
   * Never awaited or profiled — a territory is ~6 paged requests and must not
   * hold the sync-in-progress UI open. Delayed from here rather than from the
   * user's tap because `resetDb()` is awaited before this service is called,
   * and a fetch landing mid-purge would have its rows tombstoned.
   */
  private startRxTrendsSyncAlongsideSyncTasks(forceFullSync: boolean): void {
    // Network state, not `loadFromDBOnly`: a rep who is Offline by choice still
    // has connectivity, and the journey tab reads disk and never fetches.
    if (this.device.isDeviceRealOffline) return;

    setTimeout(
      () => void this.rxTrendsDataService.syncRxTrends(forceFullSync),
      RX_TRENDS_SYNC_START_DELAY_MS,
    );
  }

  private async _syncDataInternal(forceFullSync = false, loadFromDBOnly = false, forceNetwork?: boolean, isLoginSync = false) {
    const syncStartedAt = performance.now();
    const dataRangeWithFutureBoundBySixMonths = this.authenticationService.getFromToDateRangeInUTCMiliSec(undefined);
    this.clearFilter();
    this.utilityService.sync_error = [];
    this.utilityService.sync_service = [];
    this.deltaService.resetSyncEntityList();


    // Priority: DB_ONLY > FULL_SYNC > LOGIN_SYNC > DELTA_SYNC
    // forceFullSync must be checked before isLoginSync so a login-triggered full sync
    // is correctly labelled FULL_SYNC, not LOGIN_SYNC.
    const syncType = loadFromDBOnly ? 'DB_ONLY' : forceFullSync ? 'FULL_SYNC' : isLoginSync ? 'LOGIN_SYNC' : 'DELTA_SYNC';
    const rootId = this.syncProfilerService.startSession(syncType, syncType);
    // Create spans for the two major sequential groups before kicking off the Promise.allSettled,
    // so that concurrent siblings are correctly parented to the root span.
    const activitiesGroupId = this.syncProfilerService.beginSpan('activities_group', rootId);
    const formsAccountsGroupId = this.syncProfilerService.beginSpan('forms_accounts_contacts_group', rootId);

    const lazyLoadingResults = this.syncLazyLoading(forceFullSync, loadFromDBOnly);

    this.startRxTrendsSyncAlongsideSyncTasks(forceFullSync);

    let syncResults: { success: boolean; errors: Array<{ service: string; error: any }> } = { success: true, errors: [] };
    try {
      const syncTasks: (() => Promise<any>)[] = [
        () => (async () => {
          // Fix 3: Stage 2 (field option sets) has no dependency on Stage 1 (activities) — run in parallel
          // Stage 3 needs both Stage 1 (activities in memory) and Stage 2 (config field values), so it waits for both
          await Promise.all([
            this.syncProfilerService.timeAsync('activities_stage1_core_sync', () => Promise.allSettled([
              this.syncProfilerService.timeAsyncWithSpan('presentations_sync', (presSpanId) => this.presentationService.getPresentation(forceNetwork, loadFromDBOnly, presSpanId), activitiesGroupId),
              this.syncProfilerService.timeAsyncWithSpan('resources_sync', (resSpanId) => this.resourceService.getResources(loadFromDBOnly, resSpanId), activitiesGroupId),
              this.activityService.syncActivities(dataRangeWithFutureBoundBySixMonths, loadFromDBOnly, forceFullSync, activitiesGroupId)
            ]), activitiesGroupId),
            this.syncProfilerService.timeAsync('activities_stage2_field_options', () => Promise.allSettled([
              this.activityService.populateHCPInteractionField(),
              this.activityService.getAppointmentFieldOptionSetValues(loadFromDBOnly),
              this.activityService.getRecommendedEngagementPeriodFieldOptionSetValues(loadFromDBOnly),
              this.activityService.getPhoneCallFieldOptionSetValues(loadFromDBOnly),
              this.activityService.fetchAccountVisitFormatFieldConfig(loadFromDBOnly),
              this.activityService.syncConfigFieldLookupValues(loadFromDBOnly, forceFullSync),
            ]), activitiesGroupId),
          ]);
          await this.syncProfilerService.timeAsyncWithSpan('activities_stage3_config_updates', (stage3Id) => Promise.allSettled([
            this.syncProfilerService.timeAsync('config_fields_appointments', () => this.activityService.updateActivitiesForConfigField(ActivityType.Appointment, forceFullSync, loadFromDBOnly, stage3Id), stage3Id),
            this.syncProfilerService.timeAsync('config_fields_phonecalls', () => this.activityService.updateActivitiesForConfigField(ActivityType.PhoneCall, forceFullSync, loadFromDBOnly, stage3Id), stage3Id)
          ]), activitiesGroupId);
        })().finally(() => this.syncProfilerService.endSpan(activitiesGroupId)),
        () => this.syncProfilerService.timeAsync('call_plans', () => this.callPlanService.getCallPlans(dataRangeWithFutureBoundBySixMonths, forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('user_position_edge_analytics', () => this.callPlanService.getUserPositionEdgeAnalyticsMetrics(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('users_positions_master_data', () => this.activityService.getUsersPositionsMasterData(loadFromDBOnly), rootId),

        // this.activityService.getAccompaniedUsers(loadFromDBOnly),
        () => this.syncProfilerService.timeAsync('user_datetime_settings', () => this.activityService.getUserDateTimeSettingsByBusinessUnitId(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('contacts_tool_settings', () => this.activityService.getContactsToolSettingsByBusinessUnitId(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('meeting_content_reasons', () => this.activityService.getMeetingContentReasonsByBusinessUnitId(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('customer_segment', () => this.schedulerDataService.fetchCustomerSegment(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('scheduler_prioritize', () => this.schedulerDataService.fetchPrioritize(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('scheduler_zip', () => this.schedulerDataService.fetchZip(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('scheduler_city', () => this.schedulerDataService.fetchCity(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('contact_specialties', () => this.contactService.fetchSpecialties(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('contact_interactions', () => this.contactService.syncContactInteractionsByDays(loadFromDBOnly), rootId),
        () => (async () => {
          const contactProfileSpanId = this.syncProfilerService.beginSpan('contact_profile_data', rootId);
          try {
            await this.contactService.syncContactProfileData(forceFullSync, loadFromDBOnly, contactProfileSpanId);
          } finally {
            this.syncProfilerService.endSpan(contactProfileSpanId);
          }
        })(),
        // this.contactService.syncCustomerTag(loadFromDBOnly),
        () => this.syncProfilerService.timeAsync('account_tags', () => this.accountService.syncAllTags(loadFromDBOnly), rootId),
        // this.presentationService.syncPresentationTag(loadFromDBOnly),
        // this.resourceService.syncResourceTag(loadFromDBOnly),
        () => this.syncProfilerService.timeAsyncWithSpan('samples', (spanId) => this.sampleDataService.syncSamples(forceFullSync, loadFromDBOnly, spanId), rootId),
        () => this.syncProfilerService.timeAsyncWithSpan('sample_lots', (spanId) => this.sampleDataService.syncLots(dataRangeWithFutureBoundBySixMonths, forceFullSync, loadFromDBOnly, spanId), rootId),
        () => this.syncProfilerService.timeAsyncWithSpan('customer_licenses', (spanId) => this.sampleDataService.syncCustomerLicenses(forceFullSync, loadFromDBOnly, spanId), rootId),
        () => this.syncProfilerService.timeAsync('meeting_types', () => this.activityService.getMeetingTypes(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('activity_subjects', () => this.activityService.getActivitySubjects(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('activity_types', () => this.activityService.getActivityTypes(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('sub_activity_types', () => this.activityService.getSubActivityTypes(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsyncWithSpan('brand_key_messages_and_brands', async (spanId) => {
          await this.syncProfilerService.timeAsync('key_messages_by_position', () => this.brandService.getKeyMessagesByPositionGroup(loadFromDBOnly), spanId);
          await this.syncProfilerService.timeAsync('brands_fetch', () => this.brandService.getBrands(loadFromDBOnly), spanId);
        }, rootId),
        () => this.syncProfilerService.timeAsync('product_indications', () => this.brandService.syncProductIndications(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('supporting_materials', () => this.brandService.syncSupportingMaterials(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('locations', () => this.locationService.getLocations(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('time_off_reasons', () => this.timeOffDataService.getTimeOffReason(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsyncWithSpan('coaching_reports', (spanId) => this.coachingReportService.getCoachingReportsMasterData(loadFromDBOnly, spanId), rootId),
        () => this.syncProfilerService.timeAsyncWithSpan('coaching_plans', (spanId) => this.coachingReportService.getCoachingPlansMasterData(forceFullSync, loadFromDBOnly, spanId), rootId),
        () => this.syncProfilerService.timeAsync('shipment_loss_reasons', () => this.allocationShipmentDataService.getShipmentLossReasons(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('adjustment_reasons', () => this.allocationAdjustmentDataService.getAdjustmentReasons(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('allocation_shipment', () => this.allocationShipmentDataService.sync(dataRangeWithFutureBoundBySixMonths, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('transfer_reasons', () => this.allocTransferDataService.getTransferReasons(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('allocation_transfer_users', () => this.allocTransferDataService.getAllocationTransferUsers(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('allocation_inventory', () => this.allocationInventoryDataService.fetchInventory(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsyncWithSpan('consents', (spanId) => this.consentService.getAllActiveConsentsMasterData(forceFullSync, loadFromDBOnly, spanId), rootId),
        () => this.syncProfilerService.timeAsyncWithSpan('email_activities', (spanId) => this.emailService.syncEmailActivitiesData(dataRangeWithFutureBoundBySixMonths, loadFromDBOnly, spanId), rootId),
        () => this.syncProfilerService.timeAsync('events_tool_activities', () => this.eventsToolDataService.syncEventsToolActivities(dataRangeWithFutureBoundBySixMonths, forceFullSync, loadFromDBOnly), rootId),
        //this.surgeryOrderDataService.syncSurgeryOrderActivities(dataRangeWithFutureBoundBySixMonths,forceFullSync,loadFromDBOnly),
        //this.sampleDataService.getConsentType(),
        // this.sampleDataService.getConsentTerms(loadFromDBOnly),
        () => this.syncProfilerService.timeAsyncWithSpan('content_matching', (spanId) => this.contentMatchingService.getContentMatching(loadFromDBOnly, spanId), rootId),
        () => this.syncProfilerService.timeAsyncWithSpan('content_matching_messages', (spanId) => this.contentMatchingService.getContentMatchingMessages(loadFromDBOnly, spanId), rootId),
        () => this.syncProfilerService.timeAsync('scheduler_patterns', () => this.schedulerDataService.fetchAllSchedulerPatterns(dataRangeWithFutureBoundBySixMonths, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('polls', () => this.pollService.sync(forceFullSync, loadFromDBOnly), rootId),
        // sdr_manual_allocations depends on case_management having populated
        // caseProductSKU (SampleDeliveryRequestService.sdrSkus reads it) —
        // case_management sits earlier in this array, but promisePool's
        // bounded concurrency only guarantees it STARTS first, not that it
        // FINISHES first. Chained in one task (mirrors the activities
        // stage1→stage2→stage3 pattern above) so the SKU list is always
        // populated before the SDR sync reads it — losing that race left
        // syncManualAllocationsForPosition silently no-op'ing (empty skuIds
        // early-return), so contacts never opened via an online SDR session
        // never got an offline allocation-eligibility snapshot.
        () => (async () => {
          await this.syncProfilerService.timeAsync('case_management', () => this.caseManagementDataService.initCaseService(loadFromDBOnly), rootId);
          await this.syncProfilerService.timeAsync('sdr_manual_allocations', () => this.sampleDeliveryRequestService.syncManualAllocationsForPosition(forceFullSync, loadFromDBOnly), rootId);
        })(),
        () => this.syncProfilerService.timeAsync('survey_forms', () => this.surveyService.getSurveyForms(forceFullSync, loadFromDBOnly), rootId),
        //this.caseManagementDataService.syncAllCases(dataRangeWithFutureBoundBySixMonths, loadFromDBOnly),
        () => this.syncProfilerService.timeAsync('xperiences', () => this.xperiencesService.fetchXperiencesData(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('sdr_rep_sync', () => this.sampleDeliveryRequestService.syncRepSdrs(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('notes_assistant_config', () => this.authDataService.fetchNotesAssistantConfiguration(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('veeva_config', () => this.veevaService.fetchConfig(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('ok_integration_config', () => this.authDataService.fetchOKIntegrationConfig(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('multilingual_labels', () => this.localizationService.fetchMultilingualLabels(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('multilingual_entities', () => this.localizationService.fetchMultilingualEntities(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('languages', () => this.sharedDataService.fetchLanguages(loadFromDBOnly), rootId),
        // Initial sync should be blocking; delta sync runs in background.
        () => this.syncProfilerService.timeAsync('edge_analytics_sync', async () => {
          const shouldRunInForeground = forceFullSync || await this.reportsDataService.shouldRunEdgeAnalyticsSyncInForeground();
          if (shouldRunInForeground) {
            await this.reportsDataService.syncFactsAndDimensions(loadFromDBOnly);
          } else {
            this.reportsDataService.syncFactsAndDimensions(loadFromDBOnly).catch(err => console.error('syncFactsAndDimensions failed (background):', err));
          }
          return true;
        }, rootId),
        () => this.syncProfilerService.timeAsync('reports_configurations', () => this.reportsDataService.fetchAndProcessConfigurations(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('tool_names_for_search', () => this.searchConfigDataService.getToolNamesForSearch(loadFromDBOnly), rootId),
        //assk simmya to check internal sequencing
        () => (async () => {
          await this.syncProfilerService.timeAsync('forms_stage1_dynamic_forms', () => Promise.allSettled([
            this.dynamicsFormService.getDynamicForms(forceFullSync, loadFromDBOnly),
            this.secInfoDataService.getSecInfoConfig(loadFromDBOnly),
            this.setBookingDataService.syncFormSectionConfiguration(loadFromDBOnly),
          ]), formsAccountsGroupId);
          await this.syncProfilerService.timeAsync('forms_stage2_accounts_contacts', () => Promise.allSettled([
            this.syncProfilerService.timeAsyncWithSpan('accounts_chain', async (spanId) => {
              // Fix 4: products_hierarchy and opportunities_data are independent of accounts_sync — run all 3 in parallel
              await Promise.allSettled([
                this.syncProfilerService.timeAsync('accounts_sync', () => this.accountService.syncAccounts(forceFullSync, loadFromDBOnly, formsAccountsGroupId), spanId),
                this.syncProfilerService.timeAsync('products_hierarchy', () => this.surgeryOrderDataService.getProductsHierarchyForSurgeryOrder(forceFullSync, loadFromDBOnly), spanId),
                this.syncProfilerService.timeAsync('opportunities_data', () => this.opportunityService.getOpportunitiesData(forceFullSync, null, loadFromDBOnly), spanId),
              ]);
            }, formsAccountsGroupId),
            // Segmentation is chained onto contacts (not run as an independent sibling) rather
            // than run fully in parallel: for orgs whose Customer_Segmentation subgrid has custom
            // Dynamics-side scoping, segmentation is sourced from data syncContacts itself just
            // fetched (see CustomerSegmentationOfflineService.usesConfiguredFormsRoute), so it
            // must run after syncContacts resolves, not alongside it. Still awaited within this
            // same stage — not the slower market-scan stage below — so segmentation is available
            // as soon as contacts are, per product guidance that segmentation (unlike adoption
            // ladder) must be usable right after sync.
            this.contactService.syncContacts(forceFullSync, loadFromDBOnly, formsAccountsGroupId)
              .then(() => this.syncProfilerService.timeAsync('customer_segmentations_only',
                () => this.marketScanService.syncCustomerSegmentationsOnly(loadFromDBOnly, forceFullSync, formsAccountsGroupId),
                formsAccountsGroupId)),
            this.customerAssessService.syncAssessMasterData(forceFullSync, loadFromDBOnly),
            this.addressService.fetchPreferredAddress(forceFullSync, loadFromDBOnly),
            this.setBookingDataService.syncSetBookingActivities(dataRangeWithFutureBoundBySixMonths, forceFullSync, loadFromDBOnly),
          ]), formsAccountsGroupId);
          await this.syncProfilerService.timeAsync('forms_stage3_post_processing', () => Promise.allSettled([
            this.localizationService.getOneKeyCodesAndLabelsData(forceFullSync, loadFromDBOnly),
            this.searchConfigDataService.getAllSavedSearches(loadFromDBOnly),
            this.sapDataService.getScientificActivities(forceFullSync, loadFromDBOnly),
            this.syncProfilerService.timeAsyncWithSpan('market_scan_master_data',
              (spanId) => this.marketScanService.syncMarketScanMasterData(dataRangeWithFutureBoundBySixMonths, loadFromDBOnly, forceFullSync, spanId),
              formsAccountsGroupId),
            //OMNI-30257: Edit business information in offline - Non-OneKey contacts
            this.dynamicsFormService.populateLookupFieldsDataForDynamicForms(loadFromDBOnly),
            this.dynamicsFormService.syncOptionSetsForMedicalInquiry(loadFromDBOnly),
            this.dynamicsFormService.syncLookupFieldsForMedicalInquiry(loadFromDBOnly),
            // Must run after forms_stage1_dynamic_forms (getDynamicForms) resolves, same as the two MI
            // form-consumers above - its fetch attribute list is now derived from this org's configured
            // MI forms (OMNI-59706), so this.dynamicForms must already be hydrated. Previously fired from
            // syncLazyLoading() with no ordering guarantee relative to getDynamicForms.
            this.medicalInquiryDataService.fetchMedicalInquiries(loadFromDBOnly),
            this.syncProfilerService.timeAsyncWithSpan('territory_chain', async (spanId) => {
              await this.syncProfilerService.timeAsync('territory_current_list_period', () => this.territoryDataService.fetchCurrentListPeriod(loadFromDBOnly), spanId);
              await this.syncProfilerService.timeAsync('territory_contacts_display', () => this.territoryDataService.fetchContactsForConfiguredDisplay(forceFullSync, loadFromDBOnly), spanId);
              await this.syncProfilerService.timeAsync('territory_notifications', () => this.territoryDataService.fetchCustomerPositionListNotifications(loadFromDBOnly), spanId);
              await this.syncProfilerService.timeAsync('territory_target_contacts', () => this.territoryDataService.fetchTargetContactIds(loadFromDBOnly), spanId);
            }, formsAccountsGroupId),
          ]), formsAccountsGroupId);
        })().finally(() => this.syncProfilerService.endSpan(formsAccountsGroupId)),
        //check internal sequence
        () => this.syncProfilerService.timeAsync('hyperlink_data', () => this.externallinksDataService.syncHyperlinkData(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('therapeutic_areas', () => this.therapeuticAreaDataService.getTherapeuticArea(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('countries', () => this.sharedDataService.getAllCountries(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('contact_events', () => this.customerEventsService.syncContactEvents(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('opportunity_connection_roles', () => this.opportunityService.getConnectionRoles(true, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('opportunity_types', () => this.opportunityService.getOpportunityTypes(true, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('opportunity_products', () => this.opportunityService.getOpportunityProductsByPositions(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('competitors', () => this.opportunityService.getCompetitorsData(true, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('opportunity_reasons', () => this.opportunityService.getOpportunityReasons(loadFromDBOnly), rootId),
        // this.opportunityService.getOpportunityOptionSets(true, loadFromDBOnly),
        () => this.syncProfilerService.timeAsync('settings', () => this.settingsService.downloadSettings(loadFromDBOnly).catch(err => console.log('setting service failed', err)), rootId),
        () => this.syncProfilerService.timeAsync('followup_action_types', () => this.followUpActivityDataService.getFollowupActiontypes(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('followup_action_status_reasons', () => this.followUpActivityDataService.getFollowupActionStatusReasons(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('events_tool_data', () => this.eventsToolDataService.syncEventToolData(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('unsolicited_meetings', () => this.activityService.getUnsolicitedMeetingsData(true, loadFromDBOnly), rootId),
        // this.sapDataService.getScientificActivities(forceFullSync, loadFromDBOnly),
        () => this.syncProfilerService.timeAsync('assets_master_data', () => this.fieldMaterialManagementService.syncAssetsMasterData(forceFullSync, loadFromDBOnly), rootId),
        //check internal sequence
        () => this.syncProfilerService.timeAsync('account_plans', () => this.accountManagementDataService.getAccountPlans(forceFullSync, null, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('marketing_business_plans', () => this.marketingPlanManagementDataService.getMarketingBusinessPlans(forceFullSync, null, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('marketing_plan_type_records', () => this.marketingPlanManagementDataService.syncMarketingBusinessPlanTypeRecords(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('currencies', () => this.marketingPlanManagementDataService.getCurrencies(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('business_units_master_list', () => this.marketingPlanManagementDataService.getBusinesUnitsMasterList(true, loadFromDBOnly), rootId),

        //check internal sequence
        () => this.syncProfilerService.timeAsync('order_price_lists', () => this.orderActivityDataService.fetchPriceLists(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('mdm_source_type_options', () => this.mdmService.getSourceTypeOptions(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('offline_fallback_notifications', () => this.myAssistantService.offlineFallbackDataNotifications(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsyncWithSpan('mdm_master_data', (spanId) => this.mdmService.syncMDMMasterData(dataRangeWithFutureBoundBySixMonths, loadFromDBOnly, spanId), rootId),
        () => this.syncProfilerService.timeAsync('next_call_objectives', () => this.nextCallObjectiveDataService.getnextCallObjectives(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('procedure_tracker_users', () => this.procedureTrackerActivityDataService.fetchAllUsers(forceFullSync, loadFromDBOnly), rootId),

        () => this.syncProfilerService.timeAsync('quote_tools', () => this.quoteService.getQuotesTools(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('quote_price_lists', () => this.quoteService.getPriceLists(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('buildings', () => this.addressDataService.getBuildings(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('team_orders_notifications', () => this.salesOrderDataService.getTeamOrdersNotifications(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('custom_notifications', () => this.myAssistantService.getCustomNotification(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('sales_order_measures', () => this.salesOrderDataService.getSalesOrderMeasures(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('pharmacovigilance_reportings', () => this.pharmacovigilanceDataService.fetchPharmacovigilanceReportings(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('pharmacovigilance_info_buttons', () => this.pharmacovigilanceDataService.fetchInfoButtonsData(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('kol_statuses', () => this.kolStatusService.syncMyKOLStatuses(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('disease_area_records', () => this.kolStatusService.syncDiseaseAreaRecords(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('meeting_objectives', () => this.meetingDataService.fetchMeetingObjectives(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('followup_action_objectives', () => this.followUpActivityDataService.fetchFollowupActionObjectives(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('dcr_approval_requests', () => this.contactService.getDCRApprovalRequestsOnline(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('medical_insights', () => this.medicalInsightService.syncMyMedicalInsights(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('activity_outcomes', () => this.surgeryOrderDataService.getActivityOutcomes(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('sub_specialties', () => this.contactService.syncSubSpecialtiesRecords(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('procedure_types', () => this.surgeryOrderDataService.fetchProceduerTypes(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('procedure_sub_types', () => this.surgeryOrderDataService.fetchProcedureSubTypes(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsyncWithSpan('procedure_contracts', async (spanId) => {
          await this.syncProfilerService.timeAsync('contract_types', () => this.procedureContractService.fetchContractTypes(forceFullSync, loadFromDBOnly), spanId);
          await this.syncProfilerService.timeAsync('k_codes', () => this.procedureContractService.fetchKCodesData(forceFullSync, loadFromDBOnly), spanId);
          await this.syncProfilerService.timeAsync('procedure_contracts_fetch', () => this.procedureContractService.fetchProcedureContracts(forceFullSync, loadFromDBOnly), spanId);
        }, rootId),
        () => this.syncProfilerService.timeAsync('shorei_master_data', () => this.surgeryOrderDataService.fetchShoreiMasterData(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('procedure_signature_type', () => this.procedureContractService.fetchProcedureSignatureType(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('procedure_contract_products', () => this.procedureContractService.fetchProcedureContractPositionGroupProducts(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('customer_addresses', () => this.accountService.fetchCustomerAddresses(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('activity_cancellation_reasons', () => this.activityService.fetchActivityCancellationReasons(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('product_family_categories', () => this.storeCheckService.getProductFamilyCategories(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('appeal_status_notifications', async () => this.appealDataService.fetchAppealStatusNotifications(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('appeal_approval_reasons', () => this.appealDataService.getfetchApprovalReasonsConfigurationByBusinessUnitId(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('presentation_user_tag_hierarchy', () => this.presentationService.getPresentaionUserTagHierarchy(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('procedure_contract_field_options', () => this.procedureContractService.syncProcedureContractConfigFieldOptionSetValues(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('marketing_journeys', () => this.contactService.fetchMarketingJourneys(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('realtime_marketing_emails', () => this.contactService.fetchRealTimeMarketingEmailsInfo(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('change_request_category_types', () => this.contactService.fetchChangeRequestCategoryTypes(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('rx_sales', () => this.rxSalesDataService.sync(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('adoption_ladder', () => this.adoptionLadderJourneyService.fetchAdoptionLadderData(loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('bricks', () => this.bricksService.sync(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('brick_positions', () => this.brickPositionService.sync(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('agent_config', () => this.agentConfigService.sync(forceFullSync, loadFromDBOnly), rootId)
          .then(() => this.syncProfilerService.timeAsync('nova_conversations', () => this.#assistantChatFeature.syncConversations(loadFromDBOnly), rootId)),
        () => this.syncProfilerService.timeAsync('voice_notes', () => this.voiceNoteService.sync(forceFullSync, loadFromDBOnly), rootId),
        // The pending count lives in memory, so after a restart the upload cycle cannot see queued
        // App UI records: loading from the device resumes the queue, every sync drains it.
        () => this.syncProfilerService.timeAsync('app_ui_records', async () => { if (loadFromDBOnly) await this.appUiRecordDataService.resumeQueue(); else await this.appUiRecordDataService.pushOfflineData(); }, rootId),
        () => this.syncProfilerService.timeAsync('sample_reconciliation', () => this.sampleReconciliationService.fetchReconciliationRequests(forceFullSync, loadFromDBOnly), rootId),
        () => this.syncProfilerService.timeAsync('meeting_expenses', () => this.meetingExpenseSyncService.sync(forceFullSync, loadFromDBOnly), rootId),
        // Order capture master data (OMNI-60747). Position-scoped only, so it has no
        // dependency on accounts or contacts and is safe as an independent pool task.
        // Gated internally on the NEW_ORDER_FLOW feature action.
        () => this.syncProfilerService.timeAsync('order_capture_master_data', () => this.serverOrdersService.syncInitialData(loadFromDBOnly, forceFullSync), rootId),
      ];
      const results = await promisePool(syncTasks, 6);
      await lazyLoadingResults;

      // Adoption ladder stays fire-and-forget, but kicks off only now — after every other sync
      // task (including the old market-scan slot) has settled — instead of mid-sync, per product
      // guidance that ladder data can lag sync completion by a few seconds. Not awaited: must not
      // delay sync:completed/refreshAgenda below. parentSpanId intentionally omitted — the
      // profiler session (endSession(), in the finally block below) will likely have already
      // ended by the time this resolves, so a span here would be orphaned anyway.
      this.marketScanService.startLadderBackgroundSync(loadFromDBOnly, forceFullSync)
        .catch(err => console.error('[adoption_ladder_sync] background kickoff failed', err));

      // Process results and collect errors
      const serviceNames = [
        'Presentations/Resources/Activities',
        'Call Plans',
        'User Position Analytics',
        'Users Positions Master Data',
        'User DateTime Settings',
        'Contacts Tool Settings',
        'Meeting Content Reasons',
        'Customer Segment',
        'Prioritize',
        'Zip',
        'City',
        'Specialties',
        'Contact Profile Data',
        'Account Tags',
        'Samples',
        'Lots',
        'Customer Licenses',
        'Meeting Types',
        'Activity Subjects',
        'Activity Types',
        'Sub Activity Types',
        'Key Messages',
        'Brands',
        'Product Indications',
        'Supporting Materials',
        'Locations',
        'Time Off Reasons',
        'Coaching Reports Master Data',
        'Coaching Plans Master Data',
        'Shipment Loss Reasons',
        'Adjustment Reasons',
        'Shipments',
        'Transfer Reasons',
        'Allocation Transfer Users',
        'Inventory',
        'Consents',
        'Email Activities',
        'Events Tool Activities',
        'Content Matching',
        'Content Matching Messages',
        'Scheduler Patterns',
        'Poll',
        'Case Service',
        'Survey Forms',
        'Xperiences',
        'Notes Assistant Config',
        'Veeva Config',
        'OK Integration Config',
        'Multilingual Labels',
        'Multilingual Entities',
        'Languages',
        'Facts and Dimensions',
        'Report Configurations',
        'Tool Names for Search',
        'Dynamic Forms',
        'Sec Info Config',
        'Form Section Config',
        'Accounts',
        'Products Hierarchy',
        'Opportunities',
        'Contacts',
        'Assessment Master Data',
        'Preferred Address',
        'Set Booking Activities',
        'OneKey Codes and Labels',
        'Saved Searches',
        'Scientific Activities',
        'Market Scan Master Data',
        'Lookup Fields Data',
        'Current List Period',
        'Contacts for Configured Display',
        'Customer Position List Notifications',
        'Target Contact IDs',
        'Hyperlink Data',
        'Therapeutic Area',
        'Countries',
        'Contact Events',
        'Connection Roles',
        'Opportunity Types',
        'Opportunity Products',
        'Competitors',
        'Opportunity Reasons',
        'Settings',
        'Followup Action Types',
        'Followup Action Status Reasons',
        'Event Tool Data',
        'Unsolicited Meetings',
        'Assets Master Data',
        'Account Plans',
        'Marketing Business Plans',
        'Marketing Business Plan Types',
        'Currencies',
        'Business Units Master List',
        'Price Lists',
        'Source Type Options',
        'Offline Fallback Notifications',
        'MDM Master Data',
        'Next Call Objectives',
        'All Users',
        'Quotes Tools',
        'Price Lists',
        'Buildings',
        'Team Orders Notifications',
        'Custom Notifications',
        'Sales Order Measures',
        'Pharmacovigilance Reportings',
        'Info Buttons Data',
        'KOL Statuses',
        'Disease Area Records',
        'Meeting Objectives',
        'Followup Action Objectives',
        'DCR Approval Requests',
        'Medical Insights',
        'Activity Outcomes',
        'Sub-Specialties Records',
        'Procedure Types',
        'Procedure Sub Types',
        'Contract Types',
        'K Codes Data',
        'Procedure Contracts',
        'Shorei Master Data',
        'Procedure Signature Type',
        'Procedure Contract Position Group Products',
        'Customer Addresses',
        'Activity Cancellation Reasons',
        'Product Family Categories',
        'Appeal Status Notifications',
        'Approval Reasons Configuration',
        'Presentation User Tag Hierarchy',
        'Procedure Contract Config Field Option Set Values',
        'Marketing Journeys',
        'Real Time Marketing Emails Info'
      ];

      // Collect all errors and log them, but don't fail the entire sync
      results.forEach((result, index) => {
        if (result.status === 'rejected') {
          syncResults.errors.push({
            service: serviceNames[index] || `Service ${index}`,
            error: result.reason
          });
          console.error(`[Sync] ${serviceNames[index]} failed: ${result.reason?.message ?? JSON.stringify(result.reason)}`);
        }
      });

      // Determine overall success - sync is considered successful if at least some services succeeded
      const successfulCount = results.filter(r => r.status === 'fulfilled').length;
      const totalCount = results.length;
      syncResults.success = successfulCount > 0; // Consider sync successful if at least one service succeeded


    } catch (error) {
      console.error(`[Sync] unexpected error after ${Math.round(performance.now() - syncStartedAt)}ms: ${error?.message ?? JSON.stringify(error)}`);
      syncResults.success = false;
      syncResults.errors.push({
        service: 'Unexpected Error',
        error: error
      });
    } finally {
      this.syncProfilerService.endSession();
      if (syncResults.success) {
        this.events.publish('refreshAgenda', 'sync successful');
      } else {
        console.warn(`[Sync] refreshAgenda skipped, sync failed — ${syncResults.errors.map(e => `${e.service}: ${e.error?.message ?? e.error}`).join('; ')}`);
        this.events.publish('refreshAgenda', 'sync failed');
      }
      this.uiService.toolsActivityActive = false;
      // Rx trends is started alongside the sync but never awaited by it, so it
      // can still be paging here — the rep is told to leave the app open, and
      // told again when it lands.
      //
      // Not on a database-only load: that load starts a trends run but shows the
      // rep no sync of its own to attach the message to.
      if (!loadFromDBOnly) this.rxTrendsDataService.notifyIfIngestOutlastsSync();
    }
  }

  private async syncLazyLoading(forceFullSync, loadFromDBOnly) {
    try {
      this.activityService.getAccompaniedUsers(loadFromDBOnly);
      this.eventsToolDataService.getSpeakers(forceFullSync, loadFromDBOnly);
      // fetchMedicalInquiries moved to forms_stage3_post_processing (see below) - it now depends on
      // getDynamicForms having resolved, which this fire-and-forget lazy-loading path doesn't guarantee.
    } catch (err) {
      console.log("failed lazy loading...")
    }
  }


  private clearFilter() {
    this.uiService.toolsActivityActive = true;
    this.uiService.agendaRefreshRequired = false;
    this.authenticationService.impersonatedUser = undefined;
    this.activityOfflineService.clearAgendaFilters();
  }

  public stopAllData() {
    this.accountOfflineService.clear();
    this.activityOfflineService.clear();
    this.brandOfflineService.clear();
    //this.callPlanOfflineService.clear();
    this.presentationOfflineService.clear();
  }
  public async connectWebsocket() {
    if (!this.device.isOffline) {
      this.websocketService.connect();
    }
  }
}
